import { initializeApp } from "firebase/app"
import {
    getAuth,
    signInWithEmailAndPassword,
    sendPasswordResetEmail,
    sendEmailVerification,
    signOut,
} from "firebase/auth"
import { getFirestore } from "firebase/firestore"

// Same Firebase project as bluebird-documentation
const firebaseConfig = {
    apiKey: "AIzaSyCXp9s1vBlm1HnAf4tC83g5AbfabBy0F2U",
    authDomain: "bluebird-documentation.firebaseapp.com",
    projectId: "bluebird-documentation",
    storageBucket: "bluebird-documentation.appspot.com",
    messagingSenderId: "65293049615",
    appId: "1:65293049615:web:077b2757723651e3cda87a",
    measurementId: "G-0Z24RWEJ2Y"
};

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db = getFirestore(app)

const loginWithEmailAndPassword = async (email, password) => {
    try {
        await signInWithEmailAndPassword(auth, email, password)
    } catch (err) {
        throw err
    }
}

const registerWithEmailAndPassword = async (email, password, turnstileToken) => {
    // Account creation goes through the backend instead of the Firebase
    // client SDK so the Turnstile captcha token can be verified
    // server-side (BBD-72).
    const response = await fetch("https://bluebirddocumentationadmin.pythonanywhere.com/users/register/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, turnstileToken })
    })

    if (!response.ok) {
        let data = {}
        try {
            data = await response.json()
        } catch (e) {
            // non-JSON error body
        }
        const error = new Error(data.error || "Registration failed. Please try again.")
        error.code = data.code
        throw error
    }

    const result = await signInWithEmailAndPassword(auth, email, password)
    await sendEmailVerification(result.user)
    return result
}

const resetPassword = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email)
    } catch (err) {
        throw err
    }
}

const resendEmailVerification = async () => {
    try {
        const user = auth.currentUser
        if (user && !user.emailVerified) {
            await sendEmailVerification(user)
            return { success: true, message: 'Verification email sent! Please check your inbox.' }
        } else if (user && user.emailVerified) {
            return { success: false, message: 'Your email is already verified.' }
        } else {
            return { success: false, message: 'No user is currently signed in.' }
        }
    } catch (err) {
        return { success: false, message: 'Failed to send verification email: ' + err.message }
    }
}

const logout = async () => {
    try {
        await signOut(auth)
    } catch (err) {
        throw err
    }
}

export {
    auth,
    db,
    loginWithEmailAndPassword,
    registerWithEmailAndPassword,
    resetPassword,
    resendEmailVerification,
    logout,
}
